import { render, staticRenderFns } from "./BankLogos.vue?vue&type=template&id=3c005308&scoped=true"
import script from "./BankLogos.vue?vue&type=script&lang=js"
export * from "./BankLogos.vue?vue&type=script&lang=js"
import style0 from "./BankLogos.vue?vue&type=style&index=0&id=3c005308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c005308",
  null
  
)

export default component.exports